import type { PharmaceuticalChemist } from "./PharmaceuticalChemist";

export interface PrescriptionDetail {
  id: string;
  name?: string;
  laboratory?: string;
  activePrinciple: string;
  concentration: string;
  posologyQuantity: number;
  posologyFormat: string;
  frequencyQuantity: number;
  frequencyPeriod: string;
  consumptionType: string;
  durationQuantity: number;
  durationPeriod: string;
  quantityToDispense: number;
  indications: string;
}

export enum PrescriptionStatus {
  ISSUED = "ISSUED",
  DISPENSED = "DISPENSED",
  HELD = "HELD",
  CANCELED = "CANCELED",
}

export enum PrescriptionDocumentType {
  SIMPLE = "SIMPLE",
  HELD = "HELD",
}

export const PrescriptionTypeMapper: Record<string, string> = {
  [PrescriptionDocumentType.SIMPLE]: "Simple",
  [PrescriptionDocumentType.HELD]: "Retenida",
};

export interface PrescriptionHolding {
  id: string;
  prescriptionId: string;
  pharmaceuticalChemistCode: string;
  pharmaceuticalChemist?: PharmaceuticalChemist;
  pharmacyRut: string;
  pharmacyName: string;
  holdingDate: number;
  activePrinciple?: string;
  concentration?: string;
  quantityToDispense?: number;
  details?: string;
}

export interface Prescription {
  id: string;
  doctorCode: string;
  patientCode: string;
  createdAt: number;
  requestId: string;
  details: PrescriptionDetail[];
  type: PrescriptionDocumentType;
  prescriptionStatus: PrescriptionStatus;
  s3uri?: string;
  holding?: PrescriptionHolding;
  holdingDate?: number;
}

export type PrescriptionSeverity = "success" | "error" | "info" | "warning";

export const PrescriptionStatusChipSeverityMapper: Record<
  PrescriptionStatus,
  PrescriptionSeverity
> = {
  [PrescriptionStatus.ISSUED]: "success",
  [PrescriptionStatus.DISPENSED]: "info",
  [PrescriptionStatus.HELD]: "warning",
  [PrescriptionStatus.CANCELED]: "error",
};

export const PrescriptionStatusMapper: Record<PrescriptionStatus, string> = {
  [PrescriptionStatus.ISSUED]: "Emitida",
  [PrescriptionStatus.DISPENSED]: "Dispensada",
  [PrescriptionStatus.HELD]: "Retenida",
  [PrescriptionStatus.CANCELED]: "Anulada",
};

export const PrescriptionQFHeaderMapper: Record<PrescriptionStatus, string> = {
  [PrescriptionStatus.ISSUED]: "Validación de receta",
  [PrescriptionStatus.DISPENSED]: "Dispensación de receta",
  [PrescriptionStatus.HELD]: "Retención de receta",
  [PrescriptionStatus.CANCELED]: "Validación de receta",
};

export const PrescriptionStatusChipTitleMapper: Record<PrescriptionStatus, string> = {
  [PrescriptionStatus.ISSUED]: "Receta por dispensar",
  [PrescriptionStatus.DISPENSED]: "Receta dispensada",
  [PrescriptionStatus.HELD]: "Receta retenida",
  [PrescriptionStatus.CANCELED]: "Documento anulado",
};

export const PrescriptionStatusChipActionMapper: Record<PrescriptionStatus, string> = {
  [PrescriptionStatus.ISSUED]: "",
  [PrescriptionStatus.DISPENSED]: "timbre",
  [PrescriptionStatus.HELD]: "retención",
  [PrescriptionStatus.CANCELED]: "cancelación",
};

export const PrescriptionQFButtonMapper: Record<PrescriptionStatus, string> = {
  [PrescriptionStatus.ISSUED]: "",
  [PrescriptionStatus.DISPENSED]: "Dispensar",
  [PrescriptionStatus.HELD]: "Retener",
  [PrescriptionStatus.CANCELED]: "",
};
